module.exports = __webpack_public_path__ + "img/auto-compras-icono.60c153f9.webp";